export const createDaysObject = (): Array<any> => {
    const days = [];
    for (let i = 1; i <= 31; i++) {
        days.push({ name: i + '', value: i + '' });
    }
    return days;
};
